
function Page01(props) {
  return (
    <div>
      <h3 className="text-center">Experimental Study</h3>
      <br />


      <p>This study explores people's top-down comprehension of visualizations data using a scatterplot, line graphs, or bar charts. You will be asked <b>12 questions</b>. The total duration should be less than <b>30 minutes</b>.</p>
      <p>In each question, you will see visualization which is  either scatterplot, line graph, or a bar chart. You will observe the visualization as to what information they are communicating and what analysis questions can be answered with the help of this chart. You will be asked two questions, and for each answer, you will be provided a free form text box for each question.</p>
      <p><b>Question 1</b>: Describe what you see in the graph?</p>
      <p><b>Question 2</b>: What questions would you be able to answer from this graph?</p>

      <div className="text-center">
        <button style={{ marginTop: '25px', width: '150px' }} className="btn btn-outline-primary" onClick={e => props.next(undefined)}>Next</button>
      </div>
    </div>
  );
}

export default Page01;
